var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafsims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.609,
    height: 41.973,
    viewBox: "0 0 153.609 41.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135.581 -229.84)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.9 233.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.567,268.494h0a17.667,17.667,0,1,1,0-35.334H171.6a2.634,2.634,0,0,1,2.634,2.634v15.033a17.67,17.67,0,0,1-17.667,17.667",
    transform: "translate(-138.9 -233.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.567,268.494h0a17.667,17.667,0,1,1,0-35.334H171.6a2.634,2.634,0,0,1,2.634,2.634v15.033A17.67,17.67,0,0,1,156.567,268.494Z",
    transform: "translate(-138.9 -233.16)",
    fill: "none",
    stroke: "#0066f5",
    strokeMiterlimit: 10,
    strokeWidth: 6.639
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.34,272.551h0a16.16,16.16,0,0,1,0-32.321h14.285a1.875,1.875,0,0,1,1.876,1.876V256.39a16.16,16.16,0,0,1-16.16,16.16",
    transform: "translate(-139.086 -237.858)",
    fill: "#0066f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.634,297.3c7.315,8.016,14.56,7.416,21.758.289a.666.666,0,0,1,1.077.765c-1.554,3.325-4.9,7.751-11.667,7.99-7.389.262-10.785-4.762-12.268-8.278a.678.678,0,0,1,1.1-.765",
    transform: "translate(-147.252 -275.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.126 243.972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.956,267.984c-1.523,0-2.366.7-2.366,1.648-.02,1.057,1.05,1.534,2.332,1.829l1.325.315c2.56.574,4.409,1.876,4.416,4.332-.007,2.7-2.121,4.416-5.718,4.416-3.577,0-5.855-1.648-5.936-4.835h3.013c.1,1.476,1.265,2.221,2.886,2.221,1.584,0,2.6-.735,2.611-1.812-.007-.993-.9-1.453-2.5-1.842l-1.6-.4c-2.49-.6-4.02-1.842-4.013-4.013-.013-2.674,2.352-4.46,5.584-4.46,3.282,0,5.439,1.812,5.483,4.439H282.48C282.359,268.662,281.446,267.984,279.956,267.984Z",
    transform: "translate(-274.01 -265.38)",
    fill: "#013856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,280.714l5.087-14.734h4.013l5.077,14.734h-3.339l-1.094-3.359h-5.315l-1.094,3.359Zm8.966-5.792-1.812-5.577h-.114l-1.812,5.577Z",
    transform: "translate(-298.947 -265.779)",
    fill: "#013856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.08,265.98h9.755v2.567h-6.641v3.51h5.993v2.567h-5.993v6.087H359.08Z",
    transform: "translate(-330.534 -265.779)",
    fill: "#013856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.936,267.984c-1.523,0-2.366.7-2.366,1.648-.02,1.057,1.05,1.534,2.332,1.829l1.325.315c2.56.574,4.409,1.876,4.416,4.332-.007,2.7-2.121,4.416-5.718,4.416-3.577,0-5.855-1.648-5.936-4.835H396c.1,1.476,1.265,2.221,2.886,2.221,1.584,0,2.6-.735,2.611-1.812-.007-.993-.9-1.453-2.5-1.842l-1.6-.4c-2.49-.6-4.02-1.842-4.013-4.013-.013-2.674,2.352-4.46,5.584-4.46,3.282,0,5.439,1.812,5.483,4.439H401.46C401.339,268.662,400.426,267.984,398.936,267.984Z",
    transform: "translate(-353.065 -265.38)",
    fill: "#013856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.054,280.714H433.94V265.98h3.114Z",
    transform: "translate(-380.274 -265.779)",
    fill: "#013856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.726,265.973l4.057,9.9h.171l4.057-9.9h3.842v14.734h-3.02v-9.59h-.121l-3.812,9.516h-2.057l-3.812-9.553h-.121V280.7h-3.02V265.97h3.835Z",
    transform: "translate(-391.537 -265.772)",
    fill: "#013856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.646,267.984c-1.523,0-2.366.7-2.366,1.648-.02,1.057,1.05,1.534,2.332,1.829l1.325.315c2.56.574,4.409,1.876,4.416,4.332-.007,2.7-2.121,4.416-5.718,4.416-3.577,0-5.855-1.648-5.936-4.835h3.013c.1,1.476,1.265,2.221,2.886,2.221,1.584,0,2.6-.735,2.611-1.812-.007-.993-.9-1.453-2.5-1.842l-1.6-.4c-2.49-.6-4.02-1.842-4.013-4.013-.013-2.674,2.352-4.46,5.584-4.46,3.282,0,5.439,1.812,5.483,4.439h-2.987C513.049,268.662,512.136,267.984,510.646,267.984Z",
    transform: "translate(-427.29 -265.38)",
    fill: "#013856"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafsims);
export default __webpack_public_path__ + "static/media/safsims.135b583eef768097d7c66fa9e8d22233.svg";
export { ForwardRef as ReactComponent };